module.exports = __webpack_public_path__ + "static/img/sc2.aad4596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc2.png
// module id = gTQv
// module chunks = 1